import React from "react";
import videoc from "../../assets/video/tv-box.mp4";
import fondobanner from "../../assets/image/stella/reventa_fondo.jpg";
import imagen from "../../assets/image/stella/installsmartv1.png";

function Question() {

    return (
        <>
            <section className="container px-5 py-20">
                <div className="text-center mb-10"><h4
                    className="text-[32px] md:text-[35px] leading-[1.1em] font-medium uppercase mb-0">Preguntas
                    frecuentes</h4>
                    <div className="mt-5 flex items-center gap-[5px] w-max mx-auto text-white">
                        <div className="bg-current w-1 h-1 rounded-full"></div>
                        <div className="bg-current w-1 h-1 rounded-full"></div>
                        <div className="bg-current w-1 h-1 rounded-full"></div>
                        <div className="bg-current w-10 h-1 rounded-xs"></div>
                    </div>
                    <p className="mt-4 mx-auto leading-relaxed text-white">Abajo tiene algunas respuestas a las preguntas más
                        frecuentes que se tienen sobre la aplicación y los dispositivos Amazon Fire tv stick.</p></div>
                <div className="mt-16 grid md:grid-cols-2 gap-[30px] px-[15px]">
                    <div className="relative overflow-hidden"><h6
                        className="md:px-10 md:py-5 px-5 py-2.5 font-medium leading-none bg-[#696969] uppercase mb-0">¿Cómo
                        descargar Stella TV en firestick?</h6>
                        <div
                            className="md:px-10 md:py-[30px] px-5 py-2.5 bg-[#323232] text-left text-base leading-relaxed">
                            <p className="whitespace-pre-line">Las dos maneras de instalar esta app en un amazon fire
                                stick es usando Downloader o Send Files. En este caso en el video de arriba enseñamos
                                como se hace con downloader de manera simple y rápida.</p></div>
                    </div>
                    <div className="relative overflow-hidden"><h6
                        className="md:px-10 md:py-5 px-5 py-2.5 font-medium leading-none bg-[#696969] uppercase mb-0">¿Error
                        de Stella TV en Fire Stick?</h6>
                        <div
                            className="md:px-10 md:py-[30px] px-5 py-2.5 bg-[#323232] text-left text-base leading-relaxed">
                            <p className="whitespace-pre-line">Si tiene problemas con su aplicación por favor verificar
                                los siguientes puntos: revisar la conexión de internet, revisar que tengamos la última
                                versión, verificar que la cuenta no haya caducado.</p></div>
                    </div>
                    <div className="relative overflow-hidden"><h6
                        className="md:px-10 md:py-5 px-5 py-2.5 font-medium leading-none bg-[#696969] uppercase mb-0">¿Es
                        compatible con todos los modelos?</h6>
                        <div
                            className="md:px-10 md:py-[30px] px-5 py-2.5 bg-[#323232] text-left text-base leading-relaxed">
                            <p className="whitespace-pre-line">Si. Esta app es compatible con todas las versiones y
                                generaciones de Amazon fire stick: Fire TV Stick Lite, Fire TV 4K Max, Fire TV Cube,
                                Fire TV Stick 4K Ultra HD</p></div>
                    </div>
                    <div className="relative overflow-hidden"><h6
                        className="md:px-10 md:py-5 px-5 py-2.5 font-medium leading-none bg-[#696969] uppercase mb-0">¿Qué
                        modelo recomienda de Fire tv stick?</h6>
                        <div
                            className="md:px-10 md:py-[30px] px-5 py-2.5 bg-[#323232] text-left text-base leading-relaxed">
                            <p className="whitespace-pre-line">Siempre recomendamos usar los modelos más recientes,
                                hasta la fecha el que siempre recomendamos en fire stick 4k pro. Esta versión funciona
                                perfectamente y no hay problemas con la aplicación.</p></div>
                    </div>
                    <div className="relative overflow-hidden"><h6
                        className="md:px-10 md:py-5 px-5 py-2.5 font-medium leading-none bg-[#696969] uppercase mb-0">Cómo
                        instalar Stella TV sin downloader?</h6>
                        <div
                            className="md:px-10 md:py-[30px] px-5 py-2.5 bg-[#323232] text-left text-base leading-relaxed">
                            <p className="whitespace-pre-line">Si no contamos con la app downloader o tenemos algún
                                error recomendamos usar otra aplicación llamada Send Files.</p></div>
                    </div>
                    <div className="relative overflow-hidden"><h6
                        className="md:px-10 md:py-5 px-5 py-2.5 font-medium leading-none bg-[#696969] uppercase mb-0">¿Dónde
                        puedo comprar un plan para mi Fire TV?</h6>
                        <div
                            className="md:px-10 md:py-[30px] px-5 py-2.5 bg-[#323232] text-left text-base leading-relaxed">
                            <p className="whitespace-pre-line">En nuestra web tiene todos los planes para renovar y
                                comprar un plan nuevo de Stella TV. Tenemos ofertas para planes de 1 mes, 3 meses, 6
                                meses y un año.</p></div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Question;
